var elementsTobeSlider = document.querySelectorAll('div[slide-mobile-flickity]')

function checkSlider(element) {

  var active = (element.getAttribute('slide-mobile-flickity') == 1)
  if (window.innerWidth < 768 - getScroll() || element.classList.contains('promo-per-row-7')) {

    if (!active) {
      var initIndex = element.getAttribute('data-initial-index')
      var flickity_ = new Flickity(element, {
        cellAlign: 'center',
        contains: true,
        wrapAround: true,
        pageDots: true,
        initialIndex: initIndex,
        autoPlay: true
      });

      element.setAttribute('slide-mobile-flickity', 1)
    }

  } else {

    if (active) {
      var unflickity = new Flickity(element).destroy();
      element.setAttribute('slide-mobile-flickity', 5)
    }

  }
};


function getScroll() {
  var div = document.createElement('div');
  div.style.overflowY = 'scroll';
  div.style.width = '50px';
  div.style.height = '50px';
  div.style.visibility = 'hidden';
  document.body.appendChild(div);
  var scrollWidth = div.offsetWidth - div.clientWidth;
  document.body.removeChild(div);
  return scrollWidth;
}

var elementsTobeSlider = document.querySelectorAll('div[slide-mobile-flickity]')

elementsTobeSlider.forEach(function(element_) {

  checkSlider(element_);

  window.addEventListener('resize', function() {
    checkSlider(element_);
  });
})

$(document).ready(function() {
  var windowHref = window.location.href;
  var productHandle = windowHref.split('products/')[1];

  var $i18n = document.querySelector('[data-product-form-i18n]');
  var i18nData = $i18n ? JSON.parse($i18n.textContent) : null;

  var themeLocale = Shopify.locale;

  var fv;
  var selectedSelect;
  if ($('.citem .selector-wrapper').length > 0) {
    var firstLabel = document.querySelector('.citem .selector-wrapper:first-child label')?.innerText;
    if (!firstLabel) { return false };

    if ([i18nData.selector_size, i18nData.selector_color].includes(firstLabel.toLowerCase())) {
      selectedSelect = $('.citem .selector-wrapper')[1];
      if (selectedSelect) {
        fv = selectedSelect.querySelector("select option:first-child");
      }
    } else {
      selectedSelect = $('.citem .selector-wrapper')[0];
      fv = document.querySelector('.citem .selector-wrapper:first-child select option:first-child');
    }
    selectedSelect = selectedSelect.querySelector('select');
  }

  if (fv) {
    fv = fv.value;
    var opt = document.createElement('option');
    var optionTxt = windowHref.indexOf('geschenkgutschein') > -1 ? i18nData.select_amount : i18nData.select_size;

    opt.append(optionTxt);
    opt.selected = true;

    if( selectedSelect.options.length > 1 ){
      selectedSelect.prepend(opt);
    }
  }

  if (window.location.href.indexOf('products') > -1) {
    // add option name as data attribute for each selected_or_first_available_variant
    $('.citem [for*="product-select-"]').each(function(el) {
      var optionName = this.innerText.toLowerCase();
      $(this).next().attr('data-option-handle', optionName);
    });

    if (windowHref.indexOf('geschenkgutschein') == -1) {
      var newOption = '', isSelectable = $('.citem .selector-wrapper select').length;
      if (productHandle == 'ooia-teens-hipster-schwarz') {
        newOption = '<option value="ooia-hipster">' + i18nData.larger_sizes + '</option>';
      } else if (productHandle == 'ooia-teens-slip-schwarz') {
        newOption = '<option value="ooia-slip">' + i18nData.larger_sizes + '</option>';
      } else if (productHandle == 'ooia-teens-hipster-glitzerblau-limited-edition') {
        newOption = '<option value="ooia-hipster-glitzerblau-limited-edition">' + i18nData.larger_sizes + '</option>';
      } else if (productHandle == 'ooia-teens-hipster-stripes-blau') {
        newOption = '<option value="ooia-hipster-stripes-blau">' + i18nData.larger_sizes + '</option>';
      } else if (productHandle == 'ooia-teens-hipster-rot') {
        newOption = '<option value="ooia-hipster-rot">' + i18nData.larger_sizes + '</option>';
      }

      var sizeSelector = $('.citem .selector-wrapper select[data-option="option2"]');

      if (sizeSelector.length && (isSelectable || newOption !== '') && sizeSelector[0].options.length > 1 ) {
        sizeSelector.append(newOption);
      }

      var newOption = '';
      if (productHandle == 'ooia-hipster') {
        newOption = '<option value="ooia-teens-hipster-schwarz">' + i18nData.smaller_sizes + '</option>';
      } else if (productHandle == 'ooia-hipster-stripes-blau') {
        newOption = '<option value="ooia-teens-hipster-stripes-blau">' + i18nData.smaller_sizes + '</option>';
      } else if (productHandle == 'ooia-hipster-rot') {
        newOption = '<option value="ooia-teens-hipster-rot">' + i18nData.smaller_sizes + '</option>';
      } else if (productHandle == 'ooia-hipster-glitzerblau-limited-edition') {
        newOption = '<option value="ooia-teens-hipster-glitzerblau-limited-edition">' + i18nData.smaller_sizes + '</option>';
      }

      if (sizeSelector.length && (isSelectable || newOption !== '') && sizeSelector[0].options.length > 1 ) {
        if (sizeSelector.find('option:disabled').length > 0)  {
          sizeSelector.find('option:disabled').after(newOption);
        } else {
          sizeSelector.prepend(newOption);
        }
      }
    }

    var val = "";

    var mainSelect = $(".Noneselect")[0];
    var fakeOptionsArray =[];
    if (mainSelect) {
      for (var i = 0; i < mainSelect.options.length; i++) {
        var option = mainSelect.options[i];
        if (option.hasAttribute("optionname")) {
          var fake_url = option.getAttribute("variant-path");
          var fake_variantName = option.getAttribute("value") ;
          var fake_optionName = option.getAttribute("optionname").toLowerCase();
          var array = [fake_optionName,fake_variantName,fake_url];
          fakeOptionsArray.push(array);
        }
      }
    }

    // add these new options

      var selectWrapper = $(".selector-wrapper");
      if (selectWrapper.length > 1) {
        for (var i = 0; i < selectWrapper.length; i++) {
          var select = selectWrapper[i];
          var optionName = select.querySelector("label").innerText.toLowerCase();
          var selectTag = select.querySelector("select");

          for (var x = 0; x< fakeOptionsArray.length; x++) {
            if (optionName == fakeOptionsArray[x][0]) {
              var fake_url = fakeOptionsArray[x][2];
              var fake_variantName = fakeOptionsArray[x][1];
              var newFakeOption = new Option(fake_variantName , fake_variantName);
              selectTag.append(newFakeOption);
            }
          }
        }
      }

      $('.citem .selector-wrapper select').on('change', function() {
        var $selValue = $(this).val();
        var selectElement = $(this);
        var wrapper = selectElement[0].closest(".selector-wrapper");

        if (wrapper.querySelector("label") != null) {
          var optionName = wrapper.querySelector("label").innerText.toLowerCase();
          var url = "";

          for (var x = 0; x < fakeOptionsArray.length; x++) {
            if (optionName == fakeOptionsArray[x][0] && $selValue == fakeOptionsArray[x][1]) {
              url = fakeOptionsArray[x][2];
              if (url != "") {
                window.location = `${themeLocale !== 'de' ? '/' + themeLocale : ''}${url}`;
                return;
              }
            }
          }
        }

        if ($selValue.indexOf('ooia') > -1) {
          window.location = (themeLocale === 'de' ? '' : '/' + themeLocale) + '/products/' + $selValue;
        }
      });

    function topDistance() {
      var scrollTop = $(window).scrollTop();
      elementOffset = $('h1.product_name').offset().top;
      return elementOffset - scrollTop;
    }

    $('#shopify-section-product-template').on('click', '.spr-badge-caption', function() {
      $([document.documentElement, document.body]).animate({
        scrollTop: $('#shopify-product-reviews').offset().top - 150
      }, 500);
    })


  }

  // if (windowHref.indexOf('products') > -1 ) {
  if (windowHref.indexOf('products') > -1 || windowHref.indexOf('cart') > -1) {

    if (windowHref.indexOf('cart') > -1) {
      fixedCart();
    }

    /* fixed add to cart btn on mobile and fixed bar on desktop*/
    var stickyBtn = $('.sticky-checkout-wrapper'),
      staticBtn = $('.sticky-limit'),
      btnTopOfsset;

    function fixedbtn(btn) {
      if (!btn.length) { return false; }
      btnTopOfsset = btn.offset().top + btn.height() - $(window).scrollTop() - $(window).height();

      //console.log(btnTopOfsset,$(window).height());

      if (btnTopOfsset < -($(window).height() - 90)) {
        stickyBtn.addClass('action-btn-sticky');
      } else {
        if (windowHref.indexOf('cart') == -1)
          stickyBtn.removeClass('action-btn-sticky');
        // console.log(btnTopOfsset);
      }

    };
    fixedbtn(staticBtn);

    var headH
    $(window).one('scroll', function() {
      headH = $('#desk_header').get(0).clientHeight > $('#header').get(0).clientHeight ? $('#desk_header').get(0).clientHeight : $('#header').get(0).clientHeight
      stickyBtn.css('top', headH);
    })

    $(window).on('scroll', function() {
      fixedbtn(staticBtn);
      //console.log($(window).width());
      if ($(window).width() < 799) {
        $('.cart-sticky').addClass('cart-action-btn-sticky');
      } else {
        $('.cart-sticky').removeClass('cart-action-btn-sticky');
      }
    })
  }

  //  Change select of Color to input if only one option

  var selectWrapper = $(".selector-wrapper");
  var hideElements = 0;

  if (selectWrapper.length > 1) {
    for (var i = 0; i < selectWrapper.length; i++) {
      var select = selectWrapper[i];
      var optionName = select.querySelector("label").innerText.toLowerCase();
      var selectTag = select.querySelector("select");

      for (var i = 0; i < selectTag.options.length; i++) {
        if (selectTag.options[i].innerText == i18nData.select_size) {
          selectTag.options[i].remove();
          break;
        }
      }

      if (selectTag.options.length == 1) {
        select.classList.add("hiddenClass");
        if (optionName == i18nData.selector_size) {
          document.getElementById("sizeGuide").classList.add("hiddenClass");
        }
        hideElements += 1;

        if (hideElements == 2) {
          document.getElementsByClassName("size-select-wrapper")[0].classList.add("hiddenClass");
        }

      } else {
        if ([i18nData.selector_size, i18nData.selector_color].includes(optionName)) {
          if (i == 0) {
            var selectClone = select;
            select.remove();
            selectWrapper[i + 1].after(selectClone);
            select = selectClone;
          }

          if (window.screen.width <= 480) {
            var selectedOptionName = selectTag.options[0].innerText;
            selectTag.options[0].innerText = i18nData.selector_color[0].toUpperCase() + i18nData.selector_color.substring(1) + ' ' + selectedOptionName;
          }
        } else if (optionName == i18nData.selector_size) {
          var Optionhtml = "<option selected='selected' disabled>" + i18nData.select_size + "</option>";
          selectTag.innerHTML = Optionhtml + selectTag.innerHTML;
        }
      }
    }



    //     check if only one option hide the select
      var selectWrapper = $(".selector-wrapper");
     for (var i = 0; i < selectWrapper.length; i++) {
      var select = selectWrapper[i];

      var selectTag = select.querySelector("select");
       var optionName = select.querySelector("label").innerText.toLowerCase();
       if ([i18nData.selector_size, i18nData.selector_color].includes(optionName)) {
         select.classList+= " farbeOption";

         if (i == 0) {
           $("#sizeGuide p")[0] ? $("#sizeGuide p")[0].classList.add("lowerClass") : null;
         }
       }


      // if only one option -> hid the select
      // 1- remove default option
      if (selectTag.options.length == 1) {
         select.classList.add("hideSelect");
         //console.log("hide select");
        if (optionName == i18nData.selector_size) {
          $('#sizeGuide').css("display","none");
        }
      }
     }
  }

  document.querySelector('[data-renew-privacy]').addEventListener('click', e => {
    e.preventDefault();

    if (__cmp) {
      __cmp('showScreen');
    }
  });
});


function fixedCart() {
  var checkoutButton = document.getElementById('checkout');
  if (!checkoutButton) { return false; }

  var stickyDiv = document.createElement('div')
  stickyDiv.className = "sticky-checkout-wrapper cart-sticky"
  var clonedCheckout = checkoutButton.cloneNode(true)
  clonedCheckout.classList += " clonedBtn";
  stickyDiv.innerHTML = clonedCheckout.outerHTML;

  //extra za-like layout
  var priceBox = document.createElement('div');
  priceBox.className = 'cart-price-box';

  if (jsCart.cart_original_total_price == jsCart.cart_total_price) {
    priceBox.innerHTML = '<div><span><b>Gesamtsumme </b></span> <span><b>' + Shopify.formatMoney(jsCart.cart_total_price, $('body').data('money-format')) + '</b></span></div>';
    priceBox.innerHTML += '<p>' + jsCart.settings_cart_message_short + '</p>';
  } else {
    // var total_saving_price = ;//original
    // var discount_input = document.querySelector('#booster-discount-code');
    // var discount_code = (discount_input.value =="")? discount_input.getAttribute('placeholder') : discount_input.value;
    // var saving_percent = 100- ( parseFloat(total_saving_price.substr(1, total_saving_price.length).replace(',', '.') ) * 100)/0;
    // var saved_price = (parseInt(saving_percent+1)/100) *
    // saved_price = Shopify.formatMoney(saved_price, document.querySelector('body').dataset.moneyFormat )
    var quantityDiscount = $("#quantityDiscount");
    var totalDiscountInfo = $("#totalDiscountInfo");
    priceBox.innerHTML = '<div><span>' + jsCart.i18n.subtotal + ' </span> <span>' + Shopify.formatMoney(jsCart.cart_original_total_price, $('body').data('money-format')) + '</span></div>';
    // priceBox.innerHTML += '<div><span>'+ parseInt(saving_percent+1) +'%'+ discount_code +'</span><span> -'+ saved_price +'</span></div>';
    // priceBox.innerHTML += '<div><span>Mengenrabatt</span><span> -' + Shopify.formatMoney(jsCart.cart_total_discount, $('body').data('money-format')) + '</span></div>';
    priceBox.innerHTML += quantityDiscount[0].innerHTML;
    priceBox.innerHTML += totalDiscountInfo[0].innerHTML;

    priceBox.innerHTML += '<div class="sumAfterDiscount"><span>' + jsCart.i18n.total + ' <small>' + jsCart.settings_cart_message_short + '</small> </span> <span>' + Shopify.formatMoney(jsCart.cart_total_price, $('body').data('money-format')) + '</span></div>';
  }
  stickyDiv.insertBefore(priceBox, stickyDiv.childNodes[0])
  document.getElementsByTagName('body')[0].appendChild(stickyDiv)
  document.getElementsByClassName('clonedBtn')[0].addEventListener('click', function(e) {
    e.preventDefault();
    checkoutButton.click();
    //console.log(e, checkoutButton)
  })

}
// addEventListener("load", () => {
//   let DCLS = 0;
//   new PerformanceObserver((list) => {
//     list.getEntries().forEach((entry) => {
//       if (entry.hadRecentInput)
//         return; // Ignore shifts after recent input.
//       //DCLS += entry.value;
//       //console.log(entry);
//       // console.log(entry.value);
//       // console.log(DCLS);
//     });
//   }).observe({
//     type: "largest-contentful-paint",
//     buffered: true
//   });
// });

if ( $('#desk_header').height() > 0 && $(window).width() > 798) {
  if ($('#desk_header').height() > 150) {
    $('a#pagecontent').css('padding-bottom', 150)
  } else {
    $('a#pagecontent').css('padding-bottom',$('#desk_header').height())
  }
}

if ( $('#header').height() > 0 && $(window).width() <= 798) {
  if ($('#desk_header').height() > 135) {
    $('a#pagecontent').css('padding-bottom', 135)
  } else {
    $('a#pagecontent').css('padding-bottom',$('#desk_header').height())
  }
}

$(window).on('resize', function() {
  setTimeout(() => { fixedPadding(); }, 250)
})

function fixedPadding() {
  var headerH;
  if ($(window).width() > 798) {
    headerH = $('#desk_header').height();
  } else {
    headerH = $('#header').height();
  }
  if (document.querySelector('.shopify-section-wrapper') != null) {
    headerH -= parseInt($('.shopify-section-wrapper').css('padding-top'));
  }
  $('.app-returnmagic').css({
    "padding-top": (headerH + 10) + "px"
  });
  $('#pagecontent').css({
    "padding-bottom": headerH + "px"
  });
  $('.sticky-checkout-wrapper').css({
    "top": (headerH - 2) + "px"
  });
};

if (Cookies.set('cart-x-sell') === 'dismiss') {
  $('.x-sell__inner').hide();
}

$(window).on("unload", function(e) {
  Cookies.set('cart-x-sell', null);
  Cookies.set('promo_banner', null);
});

$('body').on('click', '.x-sell-item__close', function() {
  $('.x-sell__inner').fadeOut();
  Cookies.set('cart-x-sell', 'dismiss', { expires: 30 });
});

const targetNode = document.getElementById('faq-wrapper');
const config = { childList: true, subtree: true };

const callback = function(mutationsList) {
  for(const mutation of mutationsList) {
    if (mutation.type === 'childList') {
      hideFaqs();
    }
  }
};

if (targetNode) {
  const observer = new MutationObserver(callback);
  observer.observe(targetNode, config);
}

document.addEventListener('load', initMenuSliders());

document.addEventListener('DOMContentLoaded', () => {
  hideFaqs();

  if (!navigator.share) document.querySelector('[data-share-button]')?.remove();
  $('[data-return-button]').fancybox();
  document.querySelectorAll('.swatch').forEach(swatch => swatch.querySelectorAll('.swatch-element').length < 2 ? swatch.classList.add('hidden') : null);
});

function hideFaqs () {
  const faqIds = {
    "de": ["4353", "4354", "4355", "4356", "4357", "4527", "4358", "4359", "4360", "4361", "4362", "40867", "4363", "15828", "50370", "50582", "51045"],
    "en": ["48078", "48108", "48109", "48110", "48111", "48112", "48114", "48115", "48117", "48118", "48119", "48120", "48121", "48122", "50371", "50583", "51046"]
  };

  const $groups = [...document.querySelectorAll('.cd-faq-group')];

  if ($groups.length) {
    $groups.forEach(group => {
      if (!faqIds[Shopify.locale].includes(group.getAttribute('data-id'))) {
        group.remove();
      }
    });
  }
}

function initMenuSliders () {
  [...document.querySelectorAll('.navigation-pages-slider')].forEach(itm => {
    const carousel = itm.querySelector('.navigation-pages-slider--content');

    const flkty = new Flickity(carousel, {
      pageDots: false,
      prevNextButtons: false,
      contain: true,
      freeScroll: true,
      touchVerticalScroll: false
    });

    itm.classList.add('show');
  });
}